import api from "../api/flexapi";

export const FETH_CONTACT_INFO_BEGIN = "FETH_CONTACT_INFO_BEGIN";
export const FETH_CONTACT_INFO_SUCCESS = "FETH_CONTACT_INFO_SUCCESS";
export const FETH_CONTACT_INFO_FAILED = "FETH_CONTACT_INFO_FAILED";

export function loadContactDetails(data) {
  return dispatch => {
    dispatch({ type: FETH_CONTACT_INFO_BEGIN, payload: null });

    api
      .getContactInfo(data)
      .then(response => {
        dispatch({ type: FETH_CONTACT_INFO_SUCCESS, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: FETH_CONTACT_INFO_FAILED,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./actions/contactActions.jsx